export default "__VITE_ASSET__CpsprM$5__"